import { getConfiguration } from "./configuration";

export function getRanking(el, isLive = false) {
	const systemCode = getConfiguration().sys;
	// return (isLive && el.rksl?.[systemCode]) || el.rks?.[systemCode] || el.rnk || el.rk;
	if(isLive && el.rksl?.[systemCode]) {
		return el.rksl[systemCode];
	}
	else if(!isLive && el.rks?.[systemCode]) {
		return el.rks[systemCode];
	}
	return el.rnk || el.rk;
}
